import { useEffect, useState } from "react";
import { LayoutDashboard, Settings2Icon } from "lucide-react";
import { getAccountDetails } from "service";

export const useSidebar = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [selected, setSelected] = useState<string | null>(null);

  useEffect(() => {
    const fetchUnreadMessageCount = async () => {
      const userData = await getAccountDetails();
      if (userData) {
        localStorage.setItem("user", JSON.stringify(userData));
      }
    };
    fetchUnreadMessageCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNavigation = (
    route: string,
    label: string,
    resetState: boolean = false
  ) => {
    if (route !== "threads") {
      setTimeout(() => {
        window.location.href = route;
      }, 500);
    }
  };

  const navItems = [
    {
      label: "Acquisition Hub",
      key: "acquisitionHub",
      path: process.env.REACT_APP_BUYER_APP_URL,
      icon: <LayoutDashboard className="w-5 h-5" />,
      visible: false,
    },
    {
      label: "Accounts App",
      key: "accountsApp",
      icon: <Settings2Icon className="w-5 h-5" />,
      path: process.env.REACT_APP_CLERK_PRIMARY_APP_URL,
      visible: true,
    },
  ];

  return {
    collapsed,
    setCollapsed,
    selected,
    setSelected,
    navItems,
    handleNavigation,
  };
};
